import { Card, CardContent, Link, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import runwayLogo from "../../assets/images/Runway.svg";
import WaveWhite1 from "../../assets/images/Wave-White-1.png";
import { environment } from "../../util";

export default function LandingPage() {
  const navigate = useNavigate();
  const registerLink = "/register";
  const signInLink = "/sign-in";
  useEffect(() => {
    if (environment.organization?.organizationId) {
      // For now don't allow registration for enterprise organizations
      alert("Please sign in to continue");
      navigate("/sign-in");
    }
  }, [navigate]);

  if (environment.organization?.organizationId) {
    return <></>;
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        backgroundColor: "#f8fafc",
        backgroundImage: `url(${WaveWhite1})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 1,
        }}
      >
        <Card
          sx={{
            maxWidth: 420,
            width: "100%",
            boxShadow: 6,
            p: 3,
            borderRadius: 4,
            bgcolor: "white",
            position: "relative",
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: 10,
              bgcolor: (theme) => theme.palette.primary.main,
              borderTopLeftRadius: 16,
              borderTopRightRadius: 16,
            }}
          />
          <CardContent sx={{ pt: 3 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                alt="Application Wordmark"
                src={runwayLogo}
                style={{ width: 180, marginBottom: 24 }}
                draggable={false}
              />
              <Typography
                variant="subtitle1"
                color="text.secondary"
                align="center"
                sx={{ mb: 3 }}
              >
                Seamlessly Connect, Collaborate, and Innovate Across All
                Industries
              </Typography>
              <Stack
                direction="row"
                spacing={2}
                justifyContent="center"
                sx={{ width: "100%", mt: 2 }}
              >
                {process.env.REACT_APP_ENVIRONMENT == "local" && (
                  <Link href={registerLink} underline="none" sx={{ flex: 1 }}>
                    <Button variant="contained" size="large" fullWidth>
                      Register
                    </Button>
                  </Link>
                )}
                <Link href={signInLink} underline="none" sx={{ flex: 1 }}>
                  <Button variant="outlined" size="large" fullWidth>
                    Sign In
                  </Button>
                </Link>
              </Stack>
              <Box sx={{ mt: 2, width: "100%", textAlign: "center" }}>
                <Link
                  href="https://runway.works"
                  target="_blank"
                  rel="noopener noreferrer"
                  underline="hover"
                  variant="body2"
                  sx={(t) => ({
                    color: t.palette.grey[600],
                  })}
                >
                  What is Runway?
                </Link>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
}
